export function openBlankInspectionTab(): Window | null {
  const tab = window.open("about:blank", "_blank");
  if (tab) {
    try {
      tab.opener = null;
    } catch {
      // Browsers can lock opener after the tab is created.
    }
  }

  return tab;
}

export function navigateInspectionTab(tab: Window | null, url: string): void {
  if (tab) {
    tab.location.replace(url);
    return;
  }

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}

export function closeInspectionTab(tab: Window | null): void {
  tab?.close();
}
